// extracted by mini-css-extract-plugin
export default {"title":"StepHeading_title__59HgL","description":"StepHeading_description__y2mJu"};